// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Debug Panel Styles */
.admin-debug-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #1a1a1a;
  z-index: 10000;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.admin-debug-panel {
  background: #1a1a1a;
  color: #e0e0e0;
  border-radius: 0;
  box-shadow: none;
  width: 100vw;
  height: 100vh;
  max-width: none;
  display: flex;
  flex-direction: column;
  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
  animation: slideIn 0.3s ease-out;
  border: none;
}

@keyframes slideIn {
  from { 
    opacity: 0;
    transform: translateY(-20px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
}

.admin-debug-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #333;
  background: linear-gradient(135deg, #2d2d2d, #1a1a1a);
}

.header-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.admin-debug-header h2 {
  margin: 0;
  color: #00d4aa;
  font-size: 20px;
  font-weight: 600;
}

.current-version-indicator {
  font-size: 12px;
  color: #888;
  display: flex;
  align-items: center;
  gap: 6px;
}

.version-badge {
  background: #ffc107;
  color: #000;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.admin-debug-actions {
  display: flex;
  gap: 12px;
}

.btn-debug {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
  font-weight: 500;
}

.btn-export {
  background: #0066cc;
  color: white;
}

.btn-export:hover {
  background: #0052a3;
  transform: translateY(-1px);
}

.btn-feedback {
  background: #28a745;
  color: white;
}

.btn-feedback:hover {
  background: #218838;
  transform: translateY(-1px);
}

.btn-close {
  background: #dc3545;
  color: white;
  min-width: 40px;
}

.btn-close:hover {
  background: #c82333;
  transform: translateY(-1px);
}

.btn-clear {
  background: #ffc107;
  color: #000;
}

.btn-clear:hover {
  background: #e0a800;
  transform: translateY(-1px);
}

.admin-debug-tabs {
  display: flex;
  background: #2d2d2d;
  border-bottom: 1px solid #333;
  overflow-x: auto;
}

.tab {
  padding: 16px 20px;
  border: none;
  background: transparent;
  color: #888;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  border-bottom: 3px solid transparent;
  white-space: nowrap;
  font-family: inherit;
}

.tab:hover {
  color: #e0e0e0;
  background: #333;
}

.tab.active {
  color: #00d4aa;
  background: #1a1a1a;
  border-bottom-color: #00d4aa;
}

.admin-debug-content {
  flex: 1 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.logs-panel,
.api-panel,
.user-panel,
.state-panel,
.system-panel,
.database-panel {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #333;
  background: #2d2d2d;
}

.panel-header h3 {
  margin: 0;
  color: #e0e0e0;
  font-size: 16px;
  font-weight: 600;
}

.logs-container,
.api-container,
.user-container,
.state-container,
.system-container,
.database-container {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px 24px;
}

/* Custom scrollbar */
.logs-container::-webkit-scrollbar,
.api-container::-webkit-scrollbar,
.user-container::-webkit-scrollbar,
.state-container::-webkit-scrollbar,
.system-container::-webkit-scrollbar {
  width: 8px;
}

.logs-container::-webkit-scrollbar-track,
.api-container::-webkit-scrollbar-track,
.user-container::-webkit-scrollbar-track,
.state-container::-webkit-scrollbar-track,
.system-container::-webkit-scrollbar-track {
  background: #2d2d2d;
}

.logs-container::-webkit-scrollbar-thumb,
.api-container::-webkit-scrollbar-thumb,
.user-container::-webkit-scrollbar-thumb,
.state-container::-webkit-scrollbar-thumb,
.system-container::-webkit-scrollbar-thumb {
  background: #555;
  border-radius: 4px;
}

.logs-container::-webkit-scrollbar-thumb:hover,
.api-container::-webkit-scrollbar-thumb:hover,
.user-container::-webkit-scrollbar-thumb:hover,
.state-container::-webkit-scrollbar-thumb:hover,
.system-container::-webkit-scrollbar-thumb:hover {
  background: #777;
}

/* Log entries */
.log-entry {
  margin-bottom: 12px;
  padding: 12px;
  border-radius: 6px;
  border-left: 4px solid #555;
  background: #2d2d2d;
  transition: all 0.2s ease;
}

.log-entry:hover {
  background: #333;
  transform: translateX(2px);
}

.log-entry.log-error {
  border-left-color: #dc3545;
  background: rgba(220, 53, 69, 0.1);
}

.log-entry.log-warning {
  border-left-color: #ffc107;
  background: rgba(255, 193, 7, 0.1);
}

.log-entry.log-api {
  border-left-color: #0066cc;
  background: rgba(0, 102, 204, 0.1);
}

.log-entry.log-user {
  border-left-color: #28a745;
  background: rgba(40, 167, 69, 0.1);
}

.log-entry.log-system {
  border-left-color: #6f42c1;
  background: rgba(111, 66, 193, 0.1);
}

.log-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  font-size: 12px;
}

.log-icon {
  font-size: 16px;
}

.log-time {
  color: #888;
  font-family: monospace;
}

.log-type {
  background: #555;
  color: #fff;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 600;
}

.log-message {
  color: #e0e0e0;
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 8px;
}

.log-data details {
  margin-top: 8px;
}

.log-data summary {
  cursor: pointer;
  color: #00d4aa;
  font-size: 12px;
  margin-bottom: 8px;
}

.log-data pre {
  background: #1a1a1a;
  padding: 8px;
  border-radius: 4px;
  font-size: 11px;
  overflow-x: auto;
  border: 1px solid #333;
}

/* API entries */
.api-entry {
  margin-bottom: 12px;
  padding: 12px;
  border-radius: 6px;
  background: #2d2d2d;
  border: 1px solid #333;
}

.api-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.api-method {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  color: white;
}

.method-get { background: #28a745; }
.method-post { background: #007bff; }
.method-put { background: #ffc107; color: #000; }
.method-delete { background: #dc3545; }
.method-patch { background: #6f42c1; }

.api-url {
  color: #00d4aa;
  font-size: 14px;
  flex: 1 1;
  min-width: 200px;
}

.api-time {
  color: #888;
  font-size: 12px;
}

.api-status {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.status-2 { background: #28a745; color: white; }
.status-3 { background: #17a2b8; color: white; }
.status-4 { background: #ffc107; color: #000; }
.status-5 { background: #dc3545; color: white; }

.api-details details {
  margin-top: 8px;
}

.api-details summary {
  cursor: pointer;
  color: #00d4aa;
  font-size: 12px;
  margin-bottom: 4px;
}

.api-details pre {
  background: #1a1a1a;
  padding: 8px;
  border-radius: 4px;
  font-size: 11px;
  overflow-x: auto;
  border: 1px solid #333;
  max-height: 200px;
  overflow-y: auto;
}

/* User entries */
.user-entry {
  margin-bottom: 12px;
  padding: 12px;
  border-radius: 6px;
  background: #2d2d2d;
  border-left: 4px solid #28a745;
}

.user-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.user-icon {
  font-size: 16px;
}

.user-action {
  color: #e0e0e0;
  font-weight: 500;
  flex: 1 1;
}

.user-time {
  color: #888;
  font-size: 12px;
}

.user-details {
  margin-top: 8px;
}

.user-user {
  color: #888;
  font-size: 12px;
  margin-bottom: 8px;
}

/* State panel */
.state-section {
  margin-bottom: 24px;
}

.state-section h4 {
  color: #00d4aa;
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 600;
}

.state-section pre {
  background: #2d2d2d;
  padding: 16px;
  border-radius: 6px;
  font-size: 12px;
  overflow-x: auto;
  border: 1px solid #333;
  max-height: 300px;
  overflow-y: auto;
}

/* System panel */
.system-field {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #333;
  align-items: center;
}

.system-field:last-child {
  border-bottom: none;
}

.system-field strong {
  color: #00d4aa;
  font-weight: 500;
  min-width: 150px;
}

.system-field span {
  color: #e0e0e0;
  text-align: right;
  flex: 1 1;
  font-family: monospace;
  font-size: 12px;
  word-break: break-all;
}

/* Empty state */
.empty-state {
  text-align: center;
  color: #888;
  font-style: italic;
  padding: 40px;
  font-size: 14px;
}

/* Database test panel styling */
.database-container {
  background: #1a1a1a !important;
  color: #e0e0e0 !important;
}

.database-container * {
  color: #e0e0e0 !important;
}

.database-container .DatabaseTest {
  background: #1a1a1a !important;
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
  border-radius: 0 !important;
  max-width: none !important;
  color: #e0e0e0 !important;
}

/* Force dark background for all containers */
.database-container > div,
.database-container div {
  background: #1a1a1a !important;
  color: #e0e0e0 !important;
}

/* Override DatabaseTest component styles for dark theme */
.database-container button {
  background: #0066cc !important;
  color: white !important;
  border: 1px solid #0052a3 !important;
  border-radius: 6px !important;
  padding: 10px 16px !important;
  font-size: 14px !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  margin-right: 8px !important;
  margin-bottom: 8px !important;
}

.database-container button:hover {
  background: #0052a3 !important;
  transform: translateY(-1px) !important;
}

.database-container button:disabled {
  background: #555 !important;
  color: #cccccc !important;
  cursor: not-allowed !important;
  transform: none !important;
}

.database-container h3 {
  color: #00d4aa !important;
  margin: 0 0 16px 0 !important;
  font-size: 18px !important;
  font-weight: 600 !important;
}

.database-container h4 {
  color: #00d4aa !important;
  margin: 16px 0 12px 0 !important;
  font-size: 16px !important;
  font-weight: 500 !important;
}

/* Fix all text elements */
.database-container div,
.database-container span,
.database-container p {
  color: #e0e0e0 !important;
}

/* Override any inline styles that might be causing white backgrounds */
.database-container div[style*="background"] {
  background: #2d2d2d !important;
}

.database-container div[style*="border: 1px solid #ccc"] {
  background: #2d2d2d !important;
  border: 1px solid #555 !important;
  border-radius: 6px !important;
  padding: 12px !important;
  margin: 8px 0 !important;
  color: #e0e0e0 !important;
}

/* Success state styling */
.database-container div[style*="backgroundColor: #d4edda"],
.database-container div[style*="background-color: #d4edda"],
.database-container div[style*="#d4edda"] {
  background: rgba(40, 167, 69, 0.3) !important;
  border: 1px solid #28a745 !important;
  color: #ffffff !important;
}

/* Error state styling */
.database-container div[style*="backgroundColor: #f8d7da"],
.database-container div[style*="background-color: #f8d7da"],
.database-container div[style*="#f8d7da"] {
  background: rgba(220, 53, 69, 0.3) !important;
  border: 1px solid #dc3545 !important;
  color: #ffffff !important;
}

/* Warning state styling */
.database-container div[style*="backgroundColor: #fff3cd"],
.database-container div[style*="background-color: #fff3cd"],
.database-container div[style*="#fff3cd"] {
  background: rgba(255, 193, 7, 0.3) !important;
  border: 1px solid #ffc107 !important;
  color: #ffffff !important;
}

/* Light gray/white background override */
.database-container div[style*="backgroundColor: #f9f9f9"],
.database-container div[style*="background-color: #f9f9f9"],
.database-container div[style*="#f9f9f9"] {
  background: #2d2d2d !important;
  color: #e0e0e0 !important;
}

.database-container pre {
  background: #0d1117 !important;
  color: #f0f6fc !important;
  border: 1px solid #30363d !important;
  padding: 12px !important;
  border-radius: 6px !important;
  font-size: 12px !important;
  overflow: auto !important;
  max-height: 200px !important;
}

.database-container details summary {
  color: #58a6ff !important;
  cursor: pointer !important;
  font-size: 13px !important;
  font-weight: 500 !important;
}

.database-container strong {
  color: #ffffff !important;
  font-weight: 600 !important;
}

/* Make the user info text more readable */
.database-container > div > div:first-child {
  background: #2d2d2d !important;
  color: #e0e0e0 !important;
  margin-bottom: 20px !important;
  padding: 12px !important;
  border-radius: 6px !important;
  border: 1px solid #444 !important;
}

.database-container > div > div:first-child strong {
  color: #00d4aa !important;
}

/* Test result text improvements */
.database-container div[style*="padding: 12px"] {
  color: #e0e0e0 !important;
}

.database-container small {
  color: #cccccc !important;
  font-weight: 500 !important;
}

.database-container div[style*="maxHeight: '400px'"] {
  max-height: 300px !important;
  overflow-y: auto !important;
  background: #1a1a1a !important;
}

/* Responsive design */
@media (max-width: 768px) {
  .admin-debug-panel {
    width: 100vw;
    height: 100vh;
  }
  
  .admin-debug-tabs {
    font-size: 12px;
    overflow-x: auto;
  }
  
  .tab {
    padding: 12px 16px;
    flex-shrink: 0;
  }
  
  .api-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .system-field {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .system-field span {
    text-align: left;
    margin-top: 4px;
  }

  .admin-debug-header {
    padding: 16px 20px;
  }

  .admin-debug-header h2 {
    font-size: 18px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/AdminDebugPanel.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,qDAAqD;EACrD,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;;;;EAME,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;EAME,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;;;;;EAKE,UAAU;AACZ;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA;;;;;EAKE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA,cAAc,mBAAmB,EAAE;AACnC,eAAe,mBAAmB,EAAE;AACpC,cAAc,mBAAmB,EAAE,WAAW,EAAE;AAChD,iBAAiB,mBAAmB,EAAE;AACtC,gBAAgB,mBAAmB,EAAE;;AAErC;EACE,cAAc;EACd,eAAe;EACf,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,YAAY,mBAAmB,EAAE,YAAY,EAAE;AAC/C,YAAY,mBAAmB,EAAE,YAAY,EAAE;AAC/C,YAAY,mBAAmB,EAAE,WAAW,EAAE;AAC9C,YAAY,mBAAmB,EAAE,YAAY,EAAE;;AAE/C;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAO;EACP,sBAAsB;EACtB,eAAe;EACf,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;;EAEE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,0DAA0D;AAC1D;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;;;EAGE,yBAAyB;AAC3B;;AAEA,uEAAuE;AACvE;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,6BAA6B;EAC7B,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;;;EAGE,6CAA6C;EAC7C,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;;;EAGE,6CAA6C;EAC7C,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;;;EAGE,6CAA6C;EAC7C,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;;;EAGE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;EACpC,wBAAwB;EACxB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,0CAA0C;AAC1C;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;EAC9B,wBAAwB;EACxB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Admin Debug Panel Styles */\n.admin-debug-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #1a1a1a;\n  z-index: 10000;\n  display: flex;\n  align-items: stretch;\n  justify-content: stretch;\n  animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.admin-debug-panel {\n  background: #1a1a1a;\n  color: #e0e0e0;\n  border-radius: 0;\n  box-shadow: none;\n  width: 100vw;\n  height: 100vh;\n  max-width: none;\n  display: flex;\n  flex-direction: column;\n  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;\n  animation: slideIn 0.3s ease-out;\n  border: none;\n}\n\n@keyframes slideIn {\n  from { \n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to { \n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.admin-debug-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #333;\n  background: linear-gradient(135deg, #2d2d2d, #1a1a1a);\n}\n\n.header-left {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.admin-debug-header h2 {\n  margin: 0;\n  color: #00d4aa;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.current-version-indicator {\n  font-size: 12px;\n  color: #888;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.version-badge {\n  background: #ffc107;\n  color: #000;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-weight: 600;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.admin-debug-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.btn-debug {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-family: inherit;\n  font-weight: 500;\n}\n\n.btn-export {\n  background: #0066cc;\n  color: white;\n}\n\n.btn-export:hover {\n  background: #0052a3;\n  transform: translateY(-1px);\n}\n\n.btn-feedback {\n  background: #28a745;\n  color: white;\n}\n\n.btn-feedback:hover {\n  background: #218838;\n  transform: translateY(-1px);\n}\n\n.btn-close {\n  background: #dc3545;\n  color: white;\n  min-width: 40px;\n}\n\n.btn-close:hover {\n  background: #c82333;\n  transform: translateY(-1px);\n}\n\n.btn-clear {\n  background: #ffc107;\n  color: #000;\n}\n\n.btn-clear:hover {\n  background: #e0a800;\n  transform: translateY(-1px);\n}\n\n.admin-debug-tabs {\n  display: flex;\n  background: #2d2d2d;\n  border-bottom: 1px solid #333;\n  overflow-x: auto;\n}\n\n.tab {\n  padding: 16px 20px;\n  border: none;\n  background: transparent;\n  color: #888;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  border-bottom: 3px solid transparent;\n  white-space: nowrap;\n  font-family: inherit;\n}\n\n.tab:hover {\n  color: #e0e0e0;\n  background: #333;\n}\n\n.tab.active {\n  color: #00d4aa;\n  background: #1a1a1a;\n  border-bottom-color: #00d4aa;\n}\n\n.admin-debug-content {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.logs-panel,\n.api-panel,\n.user-panel,\n.state-panel,\n.system-panel,\n.database-panel {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  border-bottom: 1px solid #333;\n  background: #2d2d2d;\n}\n\n.panel-header h3 {\n  margin: 0;\n  color: #e0e0e0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.logs-container,\n.api-container,\n.user-container,\n.state-container,\n.system-container,\n.database-container {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 24px;\n}\n\n/* Custom scrollbar */\n.logs-container::-webkit-scrollbar,\n.api-container::-webkit-scrollbar,\n.user-container::-webkit-scrollbar,\n.state-container::-webkit-scrollbar,\n.system-container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.logs-container::-webkit-scrollbar-track,\n.api-container::-webkit-scrollbar-track,\n.user-container::-webkit-scrollbar-track,\n.state-container::-webkit-scrollbar-track,\n.system-container::-webkit-scrollbar-track {\n  background: #2d2d2d;\n}\n\n.logs-container::-webkit-scrollbar-thumb,\n.api-container::-webkit-scrollbar-thumb,\n.user-container::-webkit-scrollbar-thumb,\n.state-container::-webkit-scrollbar-thumb,\n.system-container::-webkit-scrollbar-thumb {\n  background: #555;\n  border-radius: 4px;\n}\n\n.logs-container::-webkit-scrollbar-thumb:hover,\n.api-container::-webkit-scrollbar-thumb:hover,\n.user-container::-webkit-scrollbar-thumb:hover,\n.state-container::-webkit-scrollbar-thumb:hover,\n.system-container::-webkit-scrollbar-thumb:hover {\n  background: #777;\n}\n\n/* Log entries */\n.log-entry {\n  margin-bottom: 12px;\n  padding: 12px;\n  border-radius: 6px;\n  border-left: 4px solid #555;\n  background: #2d2d2d;\n  transition: all 0.2s ease;\n}\n\n.log-entry:hover {\n  background: #333;\n  transform: translateX(2px);\n}\n\n.log-entry.log-error {\n  border-left-color: #dc3545;\n  background: rgba(220, 53, 69, 0.1);\n}\n\n.log-entry.log-warning {\n  border-left-color: #ffc107;\n  background: rgba(255, 193, 7, 0.1);\n}\n\n.log-entry.log-api {\n  border-left-color: #0066cc;\n  background: rgba(0, 102, 204, 0.1);\n}\n\n.log-entry.log-user {\n  border-left-color: #28a745;\n  background: rgba(40, 167, 69, 0.1);\n}\n\n.log-entry.log-system {\n  border-left-color: #6f42c1;\n  background: rgba(111, 66, 193, 0.1);\n}\n\n.log-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 8px;\n  font-size: 12px;\n}\n\n.log-icon {\n  font-size: 16px;\n}\n\n.log-time {\n  color: #888;\n  font-family: monospace;\n}\n\n.log-type {\n  background: #555;\n  color: #fff;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.log-message {\n  color: #e0e0e0;\n  font-size: 14px;\n  line-height: 1.4;\n  margin-bottom: 8px;\n}\n\n.log-data details {\n  margin-top: 8px;\n}\n\n.log-data summary {\n  cursor: pointer;\n  color: #00d4aa;\n  font-size: 12px;\n  margin-bottom: 8px;\n}\n\n.log-data pre {\n  background: #1a1a1a;\n  padding: 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  overflow-x: auto;\n  border: 1px solid #333;\n}\n\n/* API entries */\n.api-entry {\n  margin-bottom: 12px;\n  padding: 12px;\n  border-radius: 6px;\n  background: #2d2d2d;\n  border: 1px solid #333;\n}\n\n.api-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 8px;\n  flex-wrap: wrap;\n}\n\n.api-method {\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: white;\n}\n\n.method-get { background: #28a745; }\n.method-post { background: #007bff; }\n.method-put { background: #ffc107; color: #000; }\n.method-delete { background: #dc3545; }\n.method-patch { background: #6f42c1; }\n\n.api-url {\n  color: #00d4aa;\n  font-size: 14px;\n  flex: 1;\n  min-width: 200px;\n}\n\n.api-time {\n  color: #888;\n  font-size: 12px;\n}\n\n.api-status {\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.status-2 { background: #28a745; color: white; }\n.status-3 { background: #17a2b8; color: white; }\n.status-4 { background: #ffc107; color: #000; }\n.status-5 { background: #dc3545; color: white; }\n\n.api-details details {\n  margin-top: 8px;\n}\n\n.api-details summary {\n  cursor: pointer;\n  color: #00d4aa;\n  font-size: 12px;\n  margin-bottom: 4px;\n}\n\n.api-details pre {\n  background: #1a1a1a;\n  padding: 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  overflow-x: auto;\n  border: 1px solid #333;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n/* User entries */\n.user-entry {\n  margin-bottom: 12px;\n  padding: 12px;\n  border-radius: 6px;\n  background: #2d2d2d;\n  border-left: 4px solid #28a745;\n}\n\n.user-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.user-icon {\n  font-size: 16px;\n}\n\n.user-action {\n  color: #e0e0e0;\n  font-weight: 500;\n  flex: 1;\n}\n\n.user-time {\n  color: #888;\n  font-size: 12px;\n}\n\n.user-details {\n  margin-top: 8px;\n}\n\n.user-user {\n  color: #888;\n  font-size: 12px;\n  margin-bottom: 8px;\n}\n\n/* State panel */\n.state-section {\n  margin-bottom: 24px;\n}\n\n.state-section h4 {\n  color: #00d4aa;\n  margin: 0 0 12px 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.state-section pre {\n  background: #2d2d2d;\n  padding: 16px;\n  border-radius: 6px;\n  font-size: 12px;\n  overflow-x: auto;\n  border: 1px solid #333;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n/* System panel */\n.system-field {\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 0;\n  border-bottom: 1px solid #333;\n  align-items: center;\n}\n\n.system-field:last-child {\n  border-bottom: none;\n}\n\n.system-field strong {\n  color: #00d4aa;\n  font-weight: 500;\n  min-width: 150px;\n}\n\n.system-field span {\n  color: #e0e0e0;\n  text-align: right;\n  flex: 1;\n  font-family: monospace;\n  font-size: 12px;\n  word-break: break-all;\n}\n\n/* Empty state */\n.empty-state {\n  text-align: center;\n  color: #888;\n  font-style: italic;\n  padding: 40px;\n  font-size: 14px;\n}\n\n/* Database test panel styling */\n.database-container {\n  background: #1a1a1a !important;\n  color: #e0e0e0 !important;\n}\n\n.database-container * {\n  color: #e0e0e0 !important;\n}\n\n.database-container .DatabaseTest {\n  background: #1a1a1a !important;\n  border: none !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  border-radius: 0 !important;\n  max-width: none !important;\n  color: #e0e0e0 !important;\n}\n\n/* Force dark background for all containers */\n.database-container > div,\n.database-container div {\n  background: #1a1a1a !important;\n  color: #e0e0e0 !important;\n}\n\n/* Override DatabaseTest component styles for dark theme */\n.database-container button {\n  background: #0066cc !important;\n  color: white !important;\n  border: 1px solid #0052a3 !important;\n  border-radius: 6px !important;\n  padding: 10px 16px !important;\n  font-size: 14px !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n  margin-right: 8px !important;\n  margin-bottom: 8px !important;\n}\n\n.database-container button:hover {\n  background: #0052a3 !important;\n  transform: translateY(-1px) !important;\n}\n\n.database-container button:disabled {\n  background: #555 !important;\n  color: #cccccc !important;\n  cursor: not-allowed !important;\n  transform: none !important;\n}\n\n.database-container h3 {\n  color: #00d4aa !important;\n  margin: 0 0 16px 0 !important;\n  font-size: 18px !important;\n  font-weight: 600 !important;\n}\n\n.database-container h4 {\n  color: #00d4aa !important;\n  margin: 16px 0 12px 0 !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n}\n\n/* Fix all text elements */\n.database-container div,\n.database-container span,\n.database-container p {\n  color: #e0e0e0 !important;\n}\n\n/* Override any inline styles that might be causing white backgrounds */\n.database-container div[style*=\"background\"] {\n  background: #2d2d2d !important;\n}\n\n.database-container div[style*=\"border: 1px solid #ccc\"] {\n  background: #2d2d2d !important;\n  border: 1px solid #555 !important;\n  border-radius: 6px !important;\n  padding: 12px !important;\n  margin: 8px 0 !important;\n  color: #e0e0e0 !important;\n}\n\n/* Success state styling */\n.database-container div[style*=\"backgroundColor: #d4edda\"],\n.database-container div[style*=\"background-color: #d4edda\"],\n.database-container div[style*=\"#d4edda\"] {\n  background: rgba(40, 167, 69, 0.3) !important;\n  border: 1px solid #28a745 !important;\n  color: #ffffff !important;\n}\n\n/* Error state styling */\n.database-container div[style*=\"backgroundColor: #f8d7da\"],\n.database-container div[style*=\"background-color: #f8d7da\"],\n.database-container div[style*=\"#f8d7da\"] {\n  background: rgba(220, 53, 69, 0.3) !important;\n  border: 1px solid #dc3545 !important;\n  color: #ffffff !important;\n}\n\n/* Warning state styling */\n.database-container div[style*=\"backgroundColor: #fff3cd\"],\n.database-container div[style*=\"background-color: #fff3cd\"],\n.database-container div[style*=\"#fff3cd\"] {\n  background: rgba(255, 193, 7, 0.3) !important;\n  border: 1px solid #ffc107 !important;\n  color: #ffffff !important;\n}\n\n/* Light gray/white background override */\n.database-container div[style*=\"backgroundColor: #f9f9f9\"],\n.database-container div[style*=\"background-color: #f9f9f9\"],\n.database-container div[style*=\"#f9f9f9\"] {\n  background: #2d2d2d !important;\n  color: #e0e0e0 !important;\n}\n\n.database-container pre {\n  background: #0d1117 !important;\n  color: #f0f6fc !important;\n  border: 1px solid #30363d !important;\n  padding: 12px !important;\n  border-radius: 6px !important;\n  font-size: 12px !important;\n  overflow: auto !important;\n  max-height: 200px !important;\n}\n\n.database-container details summary {\n  color: #58a6ff !important;\n  cursor: pointer !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n}\n\n.database-container strong {\n  color: #ffffff !important;\n  font-weight: 600 !important;\n}\n\n/* Make the user info text more readable */\n.database-container > div > div:first-child {\n  background: #2d2d2d !important;\n  color: #e0e0e0 !important;\n  margin-bottom: 20px !important;\n  padding: 12px !important;\n  border-radius: 6px !important;\n  border: 1px solid #444 !important;\n}\n\n.database-container > div > div:first-child strong {\n  color: #00d4aa !important;\n}\n\n/* Test result text improvements */\n.database-container div[style*=\"padding: 12px\"] {\n  color: #e0e0e0 !important;\n}\n\n.database-container small {\n  color: #cccccc !important;\n  font-weight: 500 !important;\n}\n\n.database-container div[style*=\"maxHeight: '400px'\"] {\n  max-height: 300px !important;\n  overflow-y: auto !important;\n  background: #1a1a1a !important;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .admin-debug-panel {\n    width: 100vw;\n    height: 100vh;\n  }\n  \n  .admin-debug-tabs {\n    font-size: 12px;\n    overflow-x: auto;\n  }\n  \n  .tab {\n    padding: 12px 16px;\n    flex-shrink: 0;\n  }\n  \n  .api-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .system-field {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .system-field span {\n    text-align: left;\n    margin-top: 4px;\n  }\n\n  .admin-debug-header {\n    padding: 16px 20px;\n  }\n\n  .admin-debug-header h2 {\n    font-size: 18px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
